<template>
  <!-- 质检明细报表 -->
  <div class="max_box">
    <!-- top -->
    <div class="top_box"><span class="top_span">质检明细报表</span></div>
    <!-- form -->
    <div class="form_box">
      <el-input
        size="small"
        class="selectInput"
        style="width:180px"
        placeholder="请您输入搜索任务"
      >
        <svg slot="suffix" class="icon" aria-hidden="true">
          <use xlink:href="#iconsearchicon" />
        </svg>
      </el-input>
      <!-- 日期时间框 -->
      <el-date-picker
        type="datetimerange"
        unlink-panels
        size="small"
        style="width:260px;margin-right: 10px"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="~"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        align="right"
      ></el-date-picker>
    </div>
    <!-- table -->
    <el-table class="table_box_el_table" :data="tableData" ref="el_table" size="size">
      <el-table-column label="序号" align="center" type="index" width="50"></el-table-column>
      <el-table-column label="任务名称" align="center"></el-table-column>
      <el-table-column label="质检日期" align="center"></el-table-column>
      <el-table-column label="质检周期" align="center"></el-table-column>
      <el-table-column label="受检人数" align="center"></el-table-column>
      <el-table-column label="会话通数" align="center"></el-table-column>
      <el-table-column label="会话总时长" align="center"></el-table-column>
      <el-table-column label="平均得分" align="center"></el-table-column>
      <el-table-column label="平均扣分" align="center"></el-table-column>
      <el-table-column
        label="操作"
        align="center"
        fixed="right"
        width="120px">
        <template>
          <div class="table_button_box">
            <el-tooltip class="item" effect="light" content="查看" placement="bottom">
              <el-button
                @click="showMore"
                type="text"
              >
                <svg class="icon icon-bianji" aria-hidden="true">
                  <use xlink:href="#iconxiangqing" />
                </svg>
              </el-button>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- page -->
    <!--            <Page v-bind:init_item="pageBuild" @currentPage="currentPage"/>-->
  </div>
</template>

<script>
import Page from '@/views/qc/public/PageComponent'
// import { getChatLogList, getSessionLogList, downloadFile } from '@/api/qc/realTimeReport'
export default {
  name: 'qcDetailReportList',
  components: {
    Page
  },
  data: function () {
    return {
      tableData: [
        {
          name: 1
        }
      ]
    }
  },
  methods: {
    /** 查看 */
    showMore() {
      this.$store.commit('user/setQcDetailPageIndex', { qcDetailPageIndex: 2 })
    }
  },
  /**
   * 页面加载获取页面信息
   */
  mounted() {
    // this.searchModelGroupList(true)
    // 查询技能组
    // this.querySkillGroup()
  }
}
</script>

<style scoped lang="scss">
.header-border-l {
  position: relative;
  margin-top: 5px;
  margin-bottom: 5px;
  color: #333;
  border-bottom: 1px solid #ebebeb;
  padding-left: 20px;
  padding-bottom: 10px;
  font-size: 16px;
  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 4px;
    width: 3px;
    height: 14px;
    background-color: #337eff;
  }
}
</style>
<style scoped>
.max_box{
  width: 100%;
}
.top_box{
  width: 100%;
  border-bottom: #e1e3e6 solid 1px;
  padding-top: 12px;
  padding-bottom: 9px;
  margin-bottom: 20px;
}
.top_span{
  color: #222;
  font-size: 20px;
  padding-bottom: 10px;
  border-bottom: #0080fe solid 1px;
  padding-right: 5px;
}
.form_box{
  width: 100%;
}
.table_box_el_table{
  width: 100%;
}
.right{
  float: right;
}
.el-table >>> thead tr th{
  background: #f1f1f1 !important;
  padding: 6px 0 !important;
  color: #444 !important;
}
.el-table >>> tbody tr td {
  padding: 10px 5px;
}
.selectInput {
  box-sizing: border-box;
  margin-bottom: 10px;
  margin-right: 10px;
}
.dialog_top .selectInput >>> .el-input__suffix {
  height: 34px;
}
.dialog_top .selectInput >>> .el-input__suffix .el-input__suffix-inner .icon {
  margin-top: 9px;
}
.mdialog_ico p {
  width: 36px;
  height: 36px;
  margin: 0 auto;
  background-color: #6ec3ff;
  border-radius: 50%;
  overflow: hidden;
}
</style>
